<template>
  <I18NRouteLink :to="`/${props.ruta}`">
    <li>
      <a class="dropdown-item" href="#">{{ props.texto }}</a>
    </li>
  </I18NRouteLink>
</template>

<script setup lang="ts">
import I18NRouteLink from "@/.shared/components/i18n/I18NRouteLink.vue";

const props = defineProps({
  ruta: String,
  texto: String,
});
</script>

<style lang="scss" scoped>

.dropdown-item {
  font-size: var(--font-size-body-md);
  font-weight: 500;
  color: var(--text-default-default) !important;

  &.active,
  &:active {
    color: var(--text-primary-on-action) !important;
  }
}
</style>
